import { call, put, select } from 'redux-saga/effects'
import { requestAllSchedules, loadAllSchedules } from 'workspace/saga/schedules'
import { selectToken } from 'workspace/selectors'
import api from 'lib/api/client'
import { closeForm } from '../actions'

function * jobUnbooking (action) {
  const { id } = action.payload
  const token = yield select(selectToken)

  yield call(api.put, '/location_realizations/' + id + '/unbook', {}, { token })
  yield call(requestAllSchedules)
  yield call(loadAllSchedules)
  yield put(closeForm())
}

export default jobUnbooking
